import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function EngagementTeamMembersReducer(
	state = initialState.engagementTeamMembers,
	action
) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_TEAM_MEMBERS: {
			if (action.response
				&& action.response.users
				&& action.response.users.length > 0) {
				let users = action.response.users.map((user) => {
					return {
						value: user.userId,
						label: user.engagementUserFirstName + ' ' + user.engagementUserLastName,
						initial: user.engagementUserInitials,
						firstName: user.engagementUserFirstName,
						lastName: user.engagementUserLastName,
						emailAddress: user.emailAddress
					};
				});

				// Sort by user name
				if (action.sortByName) {
					users = users.sort((a, b) =>
						a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1
					);
				}

				return users;
			}
			return state;
		}
		default:
			return state;
	}
}
